































import { Component, Vue } from "vue-property-decorator";
import { DialogsModule } from "@/store/dialogs.module";
import { AuthModule } from "@/store/auth.module";
import { EmailService } from "@/services/api/email.service";

@Component
export default class EmailConfirmationDialog extends Vue {
  get isAvailable() {
    return AuthModule.isEmailMutationAvailable;
  }

  get dialog() {
    return DialogsModule.emailConfirmationDialog;
  }
  set dialog(value: EmailDialog) {
    DialogsModule.setEmailConfirmationDialog(value);
  }

  emailExistsButNotVerified: boolean = false;
  get cardText() {
    const user = AuthModule.user as IUser;
    if (this.dialog.text) return this.dialog.text;
    if (!this.dialog.isSent && !user?.org_data.isEmailVerified) {
      if (user?.email) {
        // если email не подтверждён
        this.emailExistsButNotVerified = true;
        return this.$t("profile.organization.email.card-not-verified", {
          email: ": " + user.email,
        });
      } else {
        // если нет email
        return this.$t("profile.organization.email.card-no-email");
      }
    }
    return this.$t("profile.organization.email.card-text-send", {
      email: user?.email,
    });
  }

  public resendEmail() {
    this.dialog.isSent = true;
    EmailService.resendEmail();
  }
  public close() {
    this.dialog.show = false;
  }
}
